// extracted by mini-css-extract-plugin
module.exports = {"smallFont":"about-module--smallFont--1Ow6E","aboutBody":"about-module--aboutBody--hZ38u"};